export default "__VITE_ASSET__DbpCgxft__"